import axios from 'axios';
import { updateUrlGetParams } from '@/helpers/url';
import WebApi from '../WebApi';
class OnboardingApi extends WebApi {
    async getBranchesTitles() {
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/branch_titles`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return data.branch_titles;
    }
    ;
    async getHubNames() {
        return axios.get(`${this.urlPrefix}/front_helpers/hub_names`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    ;
    async fetchSkillNames() {
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/skill_names`);
        return data;
    }
    async categoryLocationSkillNames() {
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/category_location_skill_names`);
        return data;
    }
    async getAppointmentCategoriesData() {
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/appointment_category_kinds`);
        return data;
    }
    ;
    async categoryLocationSkillNamesForAppointment(appointment_category_id, user_id) {
        const url = updateUrlGetParams(`${this.urlPrefix}/front_helpers/location_skills_for_appointment_category`, { appointment_category_id, ...user_id && { user_id } });
        const { data } = await axios.get(url);
        return data;
    }
    async fetchHubs() {
        const { data } = await axios.get(`${this.urlPrefix}/hubs`);
        return data;
    }
    async getAppointmentCategories() {
        const { data } = await axios.get(`${this.urlPrefix}/appointment_categories`);
        return data;
    }
    async createOnboardingAppointmentCategory(payload) {
        const { data } = await axios.post(`${this.urlPrefix}/account_onboarding/appointment_categories`, payload);
        return data;
    }
    async editOnboardingAppointmentCategory(payload, id) {
        const { data } = await axios.put(`${this.urlPrefix}/account_onboarding/appointment_categories/${id}`, payload);
        return data;
    }
    async getOnboardingAppointmentCategories(payload) {
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}`;
        const { data } = await axios.get(`${this.urlPrefix}/account_onboarding/appointment_categories${urlParams}`);
        return data;
    }
    async getOnboardingAppointmentCategory(id) {
        const { data } = await axios.get(`${this.urlPrefix}/account_onboarding/appointment_categories/${id}`);
        return data;
    }
    async deleteOnboardingAppointmentCategories(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/account_onboarding/appointment_categories/${id}`);
        return data;
    }
    async createOnboardingBranch(site) {
        const { data } = await axios.post(`${this.urlPrefix}/account_onboarding/sites`, { site });
        return data;
    }
    async getOnboardingBranchesRoomsList(kind, payload) {
        const urlParams = `&pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}`;
        const { data } = await axios.get(`${this.urlPrefix}/account_onboarding/sites?kind=${kind}${urlParams}`);
        return data;
    }
    async getOnboardingAllBranchesRoomsList(kind) {
        const { data } = await axios.get(`${this.urlPrefix}/account_onboarding/sites?kind=${kind}`);
        return data;
    }
    async getOnboardingSite(id) {
        const { data } = await axios.get(`${this.urlPrefix}/account_onboarding/sites/${id}`);
        return data.site;
    }
    async getOnboardingBranchRooms(kind, id) {
        const { data } = await axios.get(`${this.urlPrefix}/account_onboarding/sites?kind=${kind}&branch_id=${id}`);
        return data;
    }
    async createOnboardingRoom(site) {
        const { data } = await axios.post(`${this.urlPrefix}/account_onboarding/sites`, { site });
        return data;
    }
    async updateOnboardingRoom(site, id) {
        const { data } = await axios.put(`${this.urlPrefix}/account_onboarding/sites/${id}`, { site });
        return data;
    }
    async deleteOnboardingRoom(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/account_onboarding/sites/${id}`);
        return data;
    }
    async deleteOnboardingBranch(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/account_onboarding/sites/${id}`);
        return data;
    }
    async updateOnboardingBranch(site, id) {
        const { data } = await axios.put(`${this.urlPrefix}/account_onboarding/sites/${id}`, { site });
        return data;
    }
    async getOnboardingHubs(payload) {
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}`;
        const { data } = await axios.get(`${this.urlPrefix}/account_onboarding/hubs${urlParams}`);
        return data;
    }
    async createOnboardingHub(hub) {
        const { data } = await axios.post(`${this.urlPrefix}/account_onboarding/hubs`, { hub });
        return data;
    }
    async deleteOnboardingHub(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/account_onboarding/hubs/${id}`);
        return data;
    }
    async updateOnboardingHub(hub, id) {
        const { data } = await axios.put(`${this.urlPrefix}/account_onboarding/hubs/${id}`, { hub });
        return data;
    }
    async getOnboardingHub(id) {
        const { data } = await axios.get(`${this.urlPrefix}/account_onboarding/hubs/${id}`);
        return data;
    }
    async getFrontHelpers(name) {
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/${name}`);
        return data;
    }
    async getGeograficCities(name, country_iso) {
        const urlParams = country_iso ? `?country_iso=${country_iso}` : '';
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/${name}${urlParams}`);
        return data;
    }
    async getGeograficDataBySearch(name, payload, searchValue, id) {
        const urlParams = `&pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}`;
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/${name}?department_id=${id}&post_code=${searchValue}${urlParams}`);
        return data;
    }
    async getGeograficDepartments(payloadData, params, country_iso) {
        const urlParams = `&pagination[per_page]=${params.per_page}&pagination[page]=${params.current_page}`;
        const countryIso = country_iso ? `&country_iso=${country_iso}` : '';
        const postCode = countryIso ? '' : `&post_code=${payloadData.post_code}`;
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/cities?department_id=${payloadData.id}${postCode}${urlParams}${countryIso}`);
        return data;
    }
    async createOnboardingAdvisor(advisor) {
        const { data } = await axios.post(`${this.urlPrefix}/account_onboarding/advisors`, { advisor });
        return data;
    }
    async updateOnboardingAdvisor(advisor, id) {
        const { data } = await axios.put(`${this.urlPrefix}/account_onboarding/advisors/${id}`, { advisor });
        return data;
    }
    async getOnboardingAdvisor(id) {
        const { data } = await axios.get(`${this.urlPrefix}/account_onboarding/advisors/${id}`);
        return data;
    }
    async getOnboardingAdvisors(payload) {
        const sortBy = payload.sort ? `&sort=${payload.sort}` : '';
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}${sortBy}`;
        const { data } = await axios.get(`${this.urlPrefix}/account_onboarding/advisors${urlParams}`);
        return data;
    }
    async deleteOnboardingAdvisor(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/account_onboarding/advisors/${id}`);
        return data;
    }
}
const onboardingApi = new OnboardingApi();
export { onboardingApi as OnboardingApi, };
